import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import { Placeholder } from "rsuite";
import { UserRegistrationChartData, UserActiveInactiveChartData,
  AppointmentChartData, RevenueChartData, ServicesAverageRating , PeakHoursOfServiceBooking
} from "../../services/reports.sevices";

const ReportCharts = ({ filter , From }) => {
    const [fullRegistrations, SetFullRegistrations] = useState("");
    const [fullActiveTrendFiltered, SetFullActiveTrendFiltered] = useState([]);
    const [appointmentChartData, SetAppointmentData] = useState("");
    const [revenueData, SetRevenueData] = useState("");
    const [servicesData, SetServicesData] = useState("");
    const [peakHoursData, SetPeakHoursData] = useState("");
    const [loadingRegistrations, setLoadingRegistrations] = useState(true);
    const [loadingActivity, setLoadingActivity] = useState(true);
    const [loadingRevenue, setLoadingRevenue] = useState(true);
    const [loadingServices, setLoadingServices] = useState(true);
    const [loadingAppointments, setLoadingAppointments] = useState(true);
    const [loadingPeakHoursOfServiceBooking, setLoadingPeakHoursOfServiceBooking] = useState(true);

  // ------------------------ Filter Data ------------------------
  const filterData = (data) => {
    const today = new Date();
    let startDate = new Date("2000-01-01");

    if (filter === "7d") startDate = new Date(today.setDate(today.getDate() - 7));
    if (filter === "30d") startDate = new Date(today.setDate(today.getDate() - 30));
    if (filter === "90d") startDate = new Date(today.setDate(today.getDate() - 90));

    return data.filter((d) => new Date(d.date) >= startDate);
  };

    /* Registrations chart */
    /* Required Data format from API: */
    /* const fullRegistrations = [ 
        { date: "2025-08-01", babes: 5, associates: 3 }, 
        { date: "2025-08-02", babes: 10, associates: 6 }, 
        { date: "2025-08-03", babes: 8, associates: 5 }, 
        { date: "2025-08-04", babes: 12, associates: 7 }
    ];*/ 
    useEffect(() => {
      if(From === 'RegistrationsBabe' || From == 'RegistrationsAssociate'){
        setLoadingRegistrations(true);
        UserRegistrationChartData().then((res) => {
            SetFullRegistrations(res.data);
            setTimeout(() => {setLoadingRegistrations(false)}, 1000);
        })
        .catch((err) => {
            console.log("error ====> ", err);
            setTimeout(() => {setLoadingRegistrations(false)}, 1000);
        });
      }
    }, [From]);

    const regSeries = fullRegistrations && fullRegistrations.length > 0
      ? From === "RegistrationsBabe"
        ? [
            {
              name: "Babes",
              data: filterData(fullRegistrations).map((d) => [
                new Date(d.date).getTime(),
                d.babes,
              ]),
            },
          ]
        : From === "RegistrationsAssociate"
        ? [
            {
              name: "Associates",
              data: filterData(fullRegistrations).map((d) => [
                new Date(d.date).getTime(),
                d.associates,
              ]),
            },
          ]
        : []
      : [];

      // pick dynamic color based on From
      const chartColors =
        From === "RegistrationsBabe"
          ? ["var(--admin_primary_color)"]
          : From === "RegistrationsAssociate"
          ? ["#19b159"]
          : ["var(--admin_primary_color)"];

      const gradientColors =
        From === "RegistrationsBabe"
          ? ["#9b8cf0"]
          : From === "RegistrationsAssociate"
          ? ["#4ade80"] 
          : ["#9b8cf0"]; 

      const regOptions = {
        chart: { 
          type: "line", 
          height: 380, 
          zoom: { enabled: false }, 
          toolbar: { show: false },
          dropShadow: { enabled: false }
        },
        xaxis: { 
          type: "datetime", 
          title: { text: "Date" },
          labels: { style: { fontSize: "13px", colors: "#6b7280", fontWeight: 500 }},
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: { 
          min: 0, 
          max: (max) => max + 2,  
          forceNiceScale: true, 
          labels: { 
            formatter: (val) => val.toFixed(0),
            style: { fontSize: "13px", colors: "#6b7280", fontWeight: 500 }
          }
        },
        stroke: { curve: "smooth", width: 3 },
        markers: { 
          size: 6, 
          colors: ["#fff"], 
          strokeColors: chartColors, // dynamic border color
          strokeWidth: 3, 
          hover: { size: 10, sizeOffset: 3 }
        },
        dataLabels: { enabled: false },
        colors: chartColors, // dynamic main line color
        fill: {
          type: "gradient",
          gradient: {
            shade: "light", 
            type: "vertical", 
            shadeIntensity: 0.6, 
            gradientToColors: gradientColors, // dynamic gradient
            opacityFrom: 0.8,
            opacityTo: 0.15,
            stops: [0, 90, 100]
          }
        },
        grid: {
          borderColor: "#e5e7eb", 
          strokeDashArray: 6, 
          xaxis: { lines: { show: true } }, 
          yaxis: { lines: { show: true } }
        },
        tooltip: { 
          enabled: true, 
          theme: "light",
          style: { fontSize: "14px", fontWeight: "bold" },
          x: { format: "dd MMM yyyy" },
          y: { formatter: (val) => `${val} Registrations` }
        },
        legend: { 
          position: 'top',  
          horizontalAlign: 'center',
          floating: true,
          markers: { width: 14, height: 14, radius: 6 },
          labels: { colors: "#374151", useSeriesColors: false },
          itemMargin: { horizontal: 12 }
        },
        title: {
          align: "center",
          style: { fontSize: "20px", fontWeight: "bold", color: "#111827", letterSpacing: "0.5px" }
        }
      };

      
      
  
    /* Activity chart (Active + Inactive together) */
    /* Required Data format from API: */
    /* const fullActiveTrend = [ 
        { date: "2025-08-01", active: 120, inactive: 45 }, 
        { date: "2025-08-02", active: 135, inactive: 48 }, 
        { date: "2025-08-03", active: 150, inactive: 50 }, 
        { date: "2025-08-04", active: 170, inactive: 52 }
    ];*/
    useEffect(() => {
      if (From === "RegistrationsBabe" || From === "RegistrationsAssociate") {
        UserActiveInactiveChartData()
          .then((res) => {
            const filteredData = filterData(res.data).filter((d) => {
              if (From === "RegistrationsBabe") {
                return d.babe.active > 0 || d.babe.inactive > 0;
              } else if (From === "RegistrationsAssociate") {
                return d.associate.active > 0 || d.associate.inactive > 0;
              }
              return false;
            });
            SetFullActiveTrendFiltered(filteredData);
            setTimeout(() => {
              setLoadingActivity(false);
            }, 1000);
          })
          .catch((err) => {
            console.log("error ====> ", err);
            setTimeout(() => {
              setLoadingActivity(false);
            }, 1000);
          });
      }
    }, [From]);    
      const activitySeries =
      fullActiveTrendFiltered && fullActiveTrendFiltered.length > 0
        ? From === "RegistrationsBabe"
          ? [
              {
                name: "Active Babe Users",
                type: "column",
                data: fullActiveTrendFiltered.map((d) => d.babe.active),
              },
              {
                name: "Inactive Babe Users",
                type: "column",
                data: fullActiveTrendFiltered.map((d) => d.babe.inactive),
              },
            ]
          : From === "RegistrationsAssociate"
          ? [
              {
                name: "Active Associate Users",
                type: "column",
                data: fullActiveTrendFiltered.map((d) => d.associate.active),
              },
              {
                name: "Inactive Associate Users",
                type: "column",
                data: fullActiveTrendFiltered.map((d) => d.associate.inactive),
              },
            ]
          : []
        : [];

      const activityOptions =
      fullActiveTrendFiltered && fullActiveTrendFiltered.length > 0
      ? {
          chart: { toolbar: { show: false }, stacked: false },
          stroke: { curve: "smooth", width: [0, 3] },
          plotOptions: { 
            bar: { 
                borderRadius: 6 ,
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "last", 
                columnWidth: "50%" 
            } 
          },
        dataLabels: { enabled: false },
          xaxis: {
            categories: fullActiveTrendFiltered.map((d) =>
              new Date(d.date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
              })
            ),
          },
          tooltip: {
            x: {
              formatter: (val, opts) => {
                // full date for tooltip
                const index = opts.dataPointIndex;
                const date = fullActiveTrendFiltered[index].date;
                return new Date(date).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                });
              },
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "vertical",
              shadeIntensity: 0.5,
              gradientToColors: ["#60a5fa", "#f87171"],
              inverseColors: false,
              opacityFrom: 0.9,
              opacityTo: 0.9,
              stops: [0, 100],
            },
          },
          colors: ["var(--admin_primary_color)", "#ef4444"],
          legend: { position: "top" },
        }
      : {};
        
    
  
    /* Revenue for subscriptions and services */
    /* Required Data format from API: */
    /* const revenueData = [ 
        { date: "2025-07-01", services: 1200 ,subscriptions : 500}, 
        { date: "2025-07-02", services: 1200 ,subscriptions : 100}, 
        { date: "2025-07-03", services: 1300 ,subscriptions : 200}, 
    ] */

    useEffect(() => {
      if(From === 'Revenue'){
        setLoadingRevenue(true);
            RevenueChartData().then((res) => {
                SetRevenueData(res.data);
                setTimeout(() => {setLoadingRevenue(false); }, 1000);
            })
            .catch((err) => {
                console.log("error ====> ", err);
                setTimeout(() => {setLoadingRevenue(false); }, 1000);
            });
      }
    }, [From]);
    const RevenueOptions = revenueData && revenueData.length > 0 ? {
        chart: { 
          type: "line", 
          height: 380, 
          zoom: { enabled: false }, 
          toolbar: { show: false },
          dropShadow: { enabled: true, top: 8, left: 4, blur: 6, opacity: 0.55 }
        },
        stroke: { curve: "smooth", width: 3 },
        markers: { 
          size: 6, 
          colors: ["#fff"], 
          strokeColors: ["var(--admin_primary_color)", "#19b159"], 
          strokeWidth: 3, 
          hover: { size: 10, sizeOffset: 3 }
        },
        xaxis: { 
          type: "datetime", 
          categories: revenueData.map((d) => d.date),
          title: { text: "Date" },
          labels: { style: { fontSize: "13px", colors: "#6b7280", fontWeight: 500 }},
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: { 
          labels: { 
            formatter: (val) => `$${val.toFixed(2)}`, 
            style: { fontSize: "13px", colors: "#6b7280", fontWeight: 500 }
          }
        },
        colors: ["var(--admin_primary_color)", "#19b159"],  // keep your colors
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            shadeIntensity: 0.6,
            gradientToColors: ["#9b8cf0", "#4ade80"], // lighter shades for nice fade
            opacityFrom: 0.85,
            opacityTo: 0.45,
            stops: [0, 100] 
          }
        },
        grid: {
          borderColor: "#e5e7eb", 
          strokeDashArray: 6, 
          xaxis: { lines: { show: true } }, 
          yaxis: { lines: { show: true } }
        },
        tooltip: { 
          enabled: true, 
          theme: "light",
          style: { fontSize: "14px", fontWeight: "bold" },
          x: { format: "dd MMM yyyy" },
          y: { formatter: (val) => `$${val.toFixed(2)}` }
        },
        legend: { 
          position: "top", 
          horizontalAlign: "center",
          floating: true,
          markers: { width: 14, height: 14, radius: 6 },
          labels: { colors: "#374151" },
          itemMargin: { horizontal: 12 }
        },
        title: {
          align: "center", 
          style: { fontSize: "20px", fontWeight: "bold", color: "#111827", letterSpacing: "0.5px" }
        }
      } : {};
    const RevenueSeries = revenueData && revenueData.length > 0 ?  [
        { name: "Services", type: "line", data: filterData(revenueData).map((d) => [new Date(d.date).getTime(), d.services])},
        { name: "Subscriptions", type: "line", data: filterData(revenueData).map((d) => [new Date(d.date).getTime(), d.subscriptions])},
    ] : [];

    /* Appointment data chart */
    /* Required Data format from API: */
    /* const appointmentData = { 
        confirmed: 12, 
        in_route: 8, 
        in_progress: 5, 
        completed: 20, 
        not_completed: 4
    }; */ 
    useEffect(() => {
      if(From === 'ServiceReports'){
        AppointmentChartData().then((res) => {
          SetAppointmentData(res.data)
          console.log("Appointment Chart Data ====> ", res.data);
          setTimeout(() => {setLoadingAppointments(false)}, 1000);
        })
        .catch((err) => {
            console.log("error ====> ", err);
            setTimeout(() => {setLoadingAppointments(false)}, 1000);
        });
      }
    }, [From]);
    const STATUS_META = {
        confirmed: { label: "Confirmed", color: "#008FFB" },
        in_route: { label: "In Route", color: "#00E396" },
        in_progress: { label: "In Progress", color: "#FEB019" },
        completed: { label: "Completed", color: "#775DD0" },
        not_completed: { label: "Not Completed", color: "#FF4560" },
        dispute: { label: "Dispute", color: "#546E7A" },
        cancelled: { label: "Cancelled", color: "#26a69a" },
        pending: { label: "Pending", color: "#f9a825" }
    };
    const AppointmentChartDataSeries = appointmentChartData && Object.keys(appointmentChartData).length > 0 ?  [{name: "Appointments", data: Object.values(appointmentChartData)} ] : [];
    const AppointmentChartDataOptions = appointmentChartData && Object.keys(appointmentChartData).length > 0 ? {
        chart: { type: "bar", height: 350, zoom: { enabled: false }, toolbar: { show: false }, 
        dropShadow: { enabled: true, top: 3, left: 2, blur: 4, opacity: 0.2 }},
        plotOptions: {
            bar: { 
                borderRadius: 8, 
                borderRadiusApplication: "end",
                borderRadiusWhenStacked: "last", 
                columnWidth: "55%", 
                distributed: true, 
                dataLabels: { position: "top" } }
        },
        colors: Object.keys(appointmentChartData).map(
        (key) => STATUS_META[key].color
        ),
        fill: {
            type: "gradient",
            gradient: { shade: "light", type: "vertical", shadeIntensity: 0.2, opacityFrom: 0.9, opacityTo: 0.6, stops: [0, 100]}
        },
        dataLabels: { enabled: false, background: { enabled: true, foreColor: "#333", borderRadius: 4, padding: 4, opacity: 0.8 }},
        grid: { borderColor: "#f1f1f1", strokeDashArray: 4 },
        xaxis: {
            type: "category",
            categories: Object.keys(appointmentChartData).map((key) => STATUS_META[key].label),
            labels: { rotate: -15, style: { fontSize: "12px", colors: "#6b7280" } }, axisBorder: { show: false }, axisTicks: { show: false }
        },
        yaxis: {
            labels: { style: { fontSize: "12px", colors: "#6b7280" } }
        },
        legend: { show: false },
    } : {};
  
    /* Services usage and Rating */

    /* Required Data format from API: */
    /* const servicesData = [ 
        { serviceTitle: "Hello", numberOfUsage: 10, averageRating: "3.2" }, 
        { serviceTitle: "Support for new mothers", numberOfUsage: 20, averageRating: "4.2" }, 
        { serviceTitle: "Experienced childcare services", numberOfUsage: 4, averageRating: "1.2" }, 
        { serviceTitle: "Professional support for seniors", numberOfUsage: 7, averageRating: "2.2" }, 
    ]; */ 

    useEffect(() => {
      if(From === 'ServiceReports'){
        setLoadingServices(true);
        ServicesAverageRating()
          .then((res) => {
              SetServicesData(res.data);
              setTimeout(() => {setLoadingServices(false)}, 1000);
          })
          .catch((err) => {   
              console.log("error ====> ", err);
              setTimeout(() => {setLoadingServices(false)}, 1000);
          });
      }
    } , [From])
    const ServiceOptions = servicesData && servicesData.length > 0 ? {
        chart: {type: "bar", height: 350, toolbar: { show: false }, background: "transparent"},
        plotOptions: { bar: { borderRadius: 8, 
            columnWidth: "55%",
            borderRadiusApplication: "end",
            borderRadiusWhenStacked: "last",
            distributed: true,dataLabels: { position: "top" }}},
        fill: {
            type: "gradient",
            gradient: { shade: "light", type: "vertical", shadeIntensity: 0.2, opacityFrom: 0.9, opacityTo: 0.6, stops: [0, 100]}
        },
        colors: ["#3b82f6", "#10b981", "#f59e0b", "#ef4444"],
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const rating = parseFloat(servicesData[opts.dataPointIndex].averageRating).toFixed(1);
                return rating > 0 ? `⭐ ${rating}` : "";
            },
            offsetY: -10,
            style: { fontSize: "13px", fontWeight: 600, colors: ["#111"],
            },
            background: { enabled: true, foreColor: "#fff", borderRadius: 6, padding: 4, opacity: 0.9, colors: ["#111"]}
        },
        xaxis: {
            categories: servicesData.map((s) => s.serviceTitle),
            labels: {
                rotate: -25, trim: true, style: { fontSize: "12px", fontWeight: 500, colors: "#444" }, formatter: function (val) {
                    return val.length > 15 ? val.match(/.{1,15}/g).join("\n") : val;
                },
            },
        },
        yaxis: {
            labels: { formatter: (val) => Math.floor(val), }
        },
        grid: { borderColor: "#f1f1f1", strokeDashArray: 4 },
        legend: { show: false },
    } : {};
    const ServiceSeries = servicesData && servicesData.length > 0 ? [{ name: "Usage Count", data: servicesData.map((s) => s.numberOfUsage) }] : [];

    /* peak hours of booking service  */
    /* peak hours of booking service  */
    /* const peakHoursData = [
        { hour: "8 AM", bookings: 5 },
        { hour: "10 AM", bookings: 15 },
        { hour: "12 PM", bookings: 20 },
        { hour: "2 PM", bookings: 10 },
        { hour: "4 PM", bookings: 18 },
        { hour: "6 PM", bookings: 12 },
    ];*/

    useEffect(() => {
      if(From === 'ServiceReports'){
        setLoadingPeakHoursOfServiceBooking(true);
        PeakHoursOfServiceBooking().then((res) => {
            SetPeakHoursData(res.data);
            setTimeout(() => {setLoadingPeakHoursOfServiceBooking(false)}, 1000);
        })
        .catch((err) => {
            console.log("error ====> ", err);
            setTimeout(() => {setLoadingPeakHoursOfServiceBooking(false)}, 1000);
        });
      }
    } , [From])
    
    const peakHoursChartOptions = peakHoursData && peakHoursData.length > 0 ? {
        chart: {
            type: "line",
            height: 350,
            zoom: { enabled: false },
            toolbar: { show: false },
            dropShadow: { enabled: true, top: 5, left: 5, blur: 5, opacity: 0.2}
        },
        dataLabels: {
            enabled: false, background: {enabled: true, borderRadius: 6, foreColor: "#fff", padding: 4, opacity: 0.8}
        },
        stroke: { curve: "smooth", width: 3, colors: ["#4f46e5"]},
        markers: {size: 6, colors: ["#fff"], strokeColors: "#4f46e5", strokeWidth: 3, hover: { size: 9 }},
        fill: {
            type: "gradient",
            gradient: {
                shade: "light", type: "vertical", shadeIntensity: 0.5, gradientToColors: ["#a78bfa"],  opacityFrom: 0.7,
                opacityTo: 0.1,stops: [0, 90, 100],
            },
        },
        grid: {
            borderColor: "#e5e7eb", strokeDashArray: 5, xaxis: { lines: { show: true } }, yaxis: { lines: { show: true } },
        },
        tooltip: {
        theme: "light",
        style: { fontSize: "14px" },
            y: { formatter: (val) => `${val} Bookings` },
        },
        xaxis: {
            categories: peakHoursData.map((h) => h.hour),
            labels: { style: { fontSize: "13px", colors: "#6b7280" }},
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            labels: { style: { fontSize: "13px", colors: "#6b7280" } },
        },
    } : {};
    
    const peakHoursChartSeries = peakHoursData && peakHoursData.length > 0 ? [
        { name: "Bookings", data: peakHoursData.map((h) => h.bookings) },
    ] : [];
  

  // ------------------------ Render ------------------------
  return (
    <div>
          {/* Registrations And Activity */}
          { !From || From === 'RegistrationsBabe' || From === 'RegistrationsAssociate' ? (
                <>
                  <div className="d-flex justify-content-between gap-4 mb-6 mb-3 two-box" style={{ maxWidth: "100%" }}>
                    <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm" style={{ borderRadius: "11px" }}>
                        <h2 className="main-content-label">{ From === 'RegistrationsBabe' ? 'Babes' : 'Associates'} Registrations</h2>
                        { !loadingRegistrations ? (
                            <>
                                {regSeries && regSeries.length > 0 ? (
                                    <Chart options={regOptions} series={regSeries} type="area" height={350} />
                                ) : (
                                    <p>No registration data available</p>
                                )}
                            </>
                            ) : (
                                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                            )}
                    </div>
                    
                    <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm" style={{ borderRadius: "11px" }}>
                        <h2 className="main-content-label">{ From === 'RegistrationsBabe' ? 'Babes' : 'Associates'} Activity</h2>
                        { !loadingActivity ? (
                            <>
                                {activitySeries && activitySeries.length > 0 ? (
                                    <Chart options={activityOptions} series={activitySeries} type="bar" height={350} />
                                ) : (
                                    <p>No activity data available</p>
                                )}
                            </>
                        ) : (
                            <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                        )}
                    </div>
                  </div>
                </>
          ) : ('')}
      
          {/* Revenue data chart */}
          { !From || From === 'Revenue' ? (
            <>
              <div className="d-flex justify-content-between gap-4 mb-6 mb-3 two-box" style={{ maxWidth: "100%" }}>
                  <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm" style={{ borderRadius: "11px" }}>
                      <h2 className="main-content-label">Revenue</h2>
                      { !loadingRevenue ? (
                          <>
                              {revenueData && revenueData.length > 0 ? (
                                  <Chart options={RevenueOptions} series={RevenueSeries} type="line" height={350} />
                              ) : ( 
                                  <p>No Appointment data Visible</p> 
                              )}
                          </>
                      ) : (
                          <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                      )}
                  </div>
              </div>
            </>
          ) : ('')}
    
          {/* Appointment data chart */}
          { !From || From === 'ServiceReports' ? (
                    <>
                      <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm mb-3" style={{ borderRadius: "11px" }}>
                        <h2 className="main-content-label">Overview of Appointments</h2>
                        { !loadingAppointments ? (
                            <>
                                {appointmentChartData && Object.keys(appointmentChartData).length  ? (
                                    <Chart options={AppointmentChartDataOptions} series={AppointmentChartDataSeries} type="bar" height={350} />
                                ) : (
                                    <p>No Appointment data Visible</p>
                                )}
                            </>
                        ) : (
                            <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                        )}
                      </div>
                    </>
          ) : ("")}   

        <div className="d-flex justify-content-between gap-4 mb-6 mb-3 two-box" style={{ maxWidth: "100%" }}>
            {/* Services usage and rating data chart */}
            { !From || From === 'ServiceReports' ? (
              <>
                <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm" style={{ borderRadius: "11px" }}>
                    <h2 className="main-content-label">Most Used Services with Ratings</h2>
                    { !loadingServices ? (
                        <>
                            {servicesData && servicesData.length > 0 ? (
                                <Chart options={ServiceOptions} series={ServiceSeries} type="bar" height={400} />
                            ) : (
                                <p>No service average Data data Visible</p>
                            )}
                        </>
                    ) : (
                        <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                    )}
                </div>
              </>
            ) : ("")}

            {/* Peak service base on hours chart */}
            { !From || From === 'ServiceReports' ? (
              <>
                <div className="flex-1 rounded-2xl bg-white p-4 shadow-sm" style={{ borderRadius: "11px" }}>
                  <h2 className="main-content-label">Peak Service hours</h2>
                  { !loadingPeakHoursOfServiceBooking ? (
                        <>
                            {peakHoursData && Object.keys(peakHoursData).length  ? (
                            <Chart options={peakHoursChartOptions} series={peakHoursChartSeries} type="line" height={350} />
                            ) : (
                                <p>No Peak Service hours data Visible</p>
                            )}
                        </>
                    ) : (
                        <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={430} rowSpacing={5} active={true} rows={1} />
                    )}
                </div>
              </>
            ) : ('')}
        </div>
    </div>
  );
};

export default ReportCharts;
